'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardGroup = function (_React$Component) {
    (0, _inherits3.default)(DashboardGroup, _React$Component);

    function DashboardGroup() {
        (0, _classCallCheck3.default)(this, DashboardGroup);
        return (0, _possibleConstructorReturn3.default)(this, (DashboardGroup.__proto__ || (0, _getPrototypeOf2.default)(DashboardGroup)).apply(this, arguments));
    }

    (0, _createClass3.default)(DashboardGroup, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                className = _props.className,
                itemHeight = _props.itemHeight,
                columnFlex = _props.columnFlex,
                others = (0, _objectWithoutProperties3.default)(_props, ['title', 'className', 'itemHeight', 'columnFlex']);

            return _react2.default.createElement(
                'div',
                others,
                this.props.children
            );
        }
    }]);
    return DashboardGroup;
}(_react2.default.Component);

DashboardGroup.propTypes = {
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    itemHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    columnFlex: _propTypes2.default.array
};
DashboardGroup.defaultProps = {
    title: '',
    itemHeight: null,
    columnFlex: null
};
exports.default = DashboardGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-dashboard@0.0.23@@alicd/crui-dashboard/lib/DashboardGroup.js
// module id = 618
// module chunks = 0